module.exports = __webpack_public_path__ + "static/media/1005952.087eb466.jpg";